function getAuth0LoginUrl() {
  const returnToUrl = `${window.xrealShopUrl}/pages/redirect`;
  const redirectUrl = `${window.xrealShopUrl}/pages/redirect?pass=unpass`;
  const auth0LoginURL = `${window.auth0Settings.auth0_domain}/authorize?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&return_to=${encodeURIComponent(returnToUrl)}&scope=SCOPE&state=STATE&redirect_uri=${encodeURIComponent(redirectUrl)}`;
  console.log('auth0 Login url', auth0LoginURL)
  return auth0LoginURL;
}

function getAuth0LogoutUrl() {
  let returnToUrl = `${window.xrealShopUrl}/account/logout`;
  if (`${window.routes.root_url}`.length > 1) {
    returnToUrl = `${window.xrealShopUrl}${window.routes.root_url}/account/logout`;
  }
  const auth0LogoutURL = `${window.auth0Settings.auth0_domain}/v2/logout?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&returnTo=${encodeURIComponent(returnToUrl)}`;
  console.log('auth0 Logout url', auth0LogoutURL)
  return auth0LogoutURL;
}

function goToAuth0({ action = 'login' }) {
  const logoutURL = getAuth0LogoutUrl();
  const loginURL = getAuth0LoginUrl();
  const auth0URL = action === 'login' ? loginURL : logoutURL;
  if (action === 'logout') {
    localStorage.removeItem('xreal-uid');
  }
  try {
    window.location.href = auth0URL;
  } catch (error) {
    console.error('Failed to navigate to Auth0 logout URL:', error);
  }
}

function getCurrentProduct() {
  let productTitle = '';
  const xCurrentProduct = document.querySelector(".product__title h1");
  if (xCurrentProduct) {
    productTitle = xCurrentProduct.textContent.trim();
  }
  return productTitle;
}

// 记录跳转登录前的页面
const XCurrentURL = window.location.href;
const xUrlParams = new URLSearchParams(window.location.search);
if (XCurrentURL.includes('login')) {
  if (xUrlParams.has('checkout_url')) {
    let checkoutUrl = xUrlParams.get('checkout_url');
    checkoutUrl = `${window.xrealShopUrl}${checkoutUrl}`;
    localStorage.setItem('xreal-currentURL', checkoutUrl);
  }
} else if (!XCurrentURL.includes('redirect')) {
  localStorage.setItem('xreal-currentURL', XCurrentURL);
}

async function getHashString36(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
  return base64Hash.slice(0, 36);
}

function parsePrice(priceStr) {
  // 正则解析：分离前缀币种、数字部分、后缀币种
  const regex = /([^\d\s,.]+)?[\s]*([\d.,]+)[\s]*([A-Z]{3})?/;
  const match = priceStr.match(regex);

  if (match) {
    let prefixCurrency = match[1]?.trim() || ''; // 前缀币种
    const rawNumber = match[2]; // 原始数字部分
    const suffixCurrency = match[3] || ''; // 后缀币种

    // 处理数字部分
    const normalizedNumber = rawNumber.replace(/,/g, ''); // 去掉千位分隔符
    const amount = parseFloat(normalizedNumber).toFixed(2); // 保留两位小数

    // 确定币种
    let currency = suffixCurrency || prefixCurrency;

    // 特殊处理前缀币种的转换
    const currencyMap = {
      '$': 'USD',
      'HK$': 'HKD',
      '€': 'EUR',
      '¥': 'JPY'
    };
    currency = currencyMap[currency] || currency;

    return {
      currency,
      amount,
    };
  } else {
    return {
      currency: '',
      amount: '0.00',
    };
  }
}

// 检测模块定时上下线时间
function checkTimeVisible(sectionClass, slideItemClass) {
  const section = document.querySelector(sectionClass);
  let visible = false;
  document.querySelectorAll(slideItemClass).forEach((slideBlock) => {
    const startStr = slideBlock.dataset.start || '1970-01-01T00:00:00';
    const endStr = slideBlock.dataset.end || '9999-12-31T23:59:59';
    const tz = slideBlock.dataset.timezone;
    const { DateTime } = luxon;
    const now = DateTime.now().setZone(tz);
    const start = DateTime.fromISO(startStr, { zone: tz });
    const end = DateTime.fromISO(endStr, { zone: tz });
    if (start.isValid && end.isValid) {
      if (now >= start && now < end) {
        slideBlock.style.display = 'block';
        visible = true;
      } else {
        slideBlock.style.display = 'none';
      }
    } else {
      console.warn('Invalid start or end time');
      slideBlock.style.display = 'none';
    }
  });
  if (!visible) {
    section.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('bis-modal');
  const trigger = document.getElementById('bis-trigger-button');
  const close = document.getElementById('bis-close');
  const form = document.getElementById('klaviyo-back-in-stock-form');
  const message = document.getElementById('bis-message');

  if (trigger && modal && close && form) {
    // 打开 Modal
    trigger.addEventListener('click', () => {
      modal.style.display = 'flex';
    });

    // 关闭 Modal
    close.addEventListener('click', () => {
      modal.style.display = 'none';
    });

    // 点击 Modal 外层关闭
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });

    // 提交表单
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = document.getElementById('bis-email').value.trim();
      const variantId = ShopifyAnalytics.meta.selectedVariantId;
      const klaviyoVariantId = `$shopify:::$default:::${variantId}`;

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": { "email": email }
              }
            },
            "channels": ["EMAIL"]
          },
          "relationships": {
            "variant": {
              "data": { "type": "catalog-variant", "id": klaviyoVariantId }
            }
          }
        }
      };

      console.log("Variant ID:", variantId);
      console.log("Payload:", payload);

      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoApiKey}`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-06-15"
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          message.style.display = 'block';
          form.reset();
          setTimeout(() => {
            modal.style.display = 'none';
            message.style.display = 'none';
          }, 2000);
        } else {
          const resData = await response.json();
          console.error(resData);
          alert("Subscription failed, please try again.");
        }
      } catch (error) {
        console.error(error);
        alert("Subscription failed, please try again.");
      }
    });
  }
});

